export default __webpack_public_path__ + "static/ReferAFriendBannerMnUnited-d86822a76ac88fb5b1a0cf547e7a264a.jpeg";